<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/MachineReport/Invoice'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">วันที่(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reInvDateStart"
                      name="reInvDateStart"
                      ref="reInvDateStart"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">วันที่(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reInvDateEnd"
                      name="reInvDateEnd"
                      ref="reInvDateEnd"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>Phase:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reInvPhase'"
                    :name="'reInvPhase'"
                    :select2-options="reInvPhaseOptions"
                    v-model="reInvPhase"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>Lot:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reInvLot'"
                    :name="'reInvLot'"
                    :select2-options="reInvLotOptions"
                    v-model="reInvLot"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>แบรนด์เครื่องเบียร์สด:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reInvBrand'"
                    :name="'reInvBrand'"
                    :select2-options="reInvBrandOptions"
                    v-model="reInvBrand"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reInvStatus'"
                    :name="'reInvStatus'"
                    :select2-options="reInvStatusOptions"
                    v-model="reInvStatus"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>เลขที่ Invoice:</label>
                  <input
                    v-model="reInvInvoice"
                    type="text"
                    class="form-control"
                    placeholder="กรุณาระบุ เลขที่ Invoice"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทสินค้า:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reInvProductTypeId'"
                    :name="'reInvProductTypeId'"
                    :select2-options="reInvProductTypeIdOptions"
                    v-model="reInvProductTypeId"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ราคาค่าเช่า(เริ่มต้น):</label>
                  <input
                    v-model="reInvPriceStart"
                    type="number"
                    class="form-control"
                    placeholder="กรุณาระบุ ราคาค่าเช่า(เริ่มต้น)"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ราคาค่าเช่า(สิ้นสุด):</label>
                  <input
                    v-model="reInvPriceEnd"
                    type="number"
                    class="form-control"
                    placeholder="กรุณาระบุ ราคาค่าเช่า(สิ้นสุด)"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>Supplier:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reInvSupplier'"
                    :name="'reInvSupplier'"
                    :select2-options="reInvSupplierOptions"
                    v-model="reInvSupplier"
                  ></select2>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button class="btn btn-outline-primary" @click="exportInvoice">
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="InvoiceTable"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all text-right" colspan="15">
                      ข้อมูล ณ วันที่ {{ reAaDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center" rowspan="2">วันที่รับวางบิล</th>
                    <th class="all text-center" rowspan="2">Invoice</th>
                    <th class="all text-center" rowspan="2">Phase</th>
                    <th class="all text-center" rowspan="2">Lot</th>
                    <th class="all text-center" rowspan="2">งวด</th>
                    <th class="all text-center" rowspan="2">Supplier</th>
                    <th class="all text-center" rowspan="2">ประเภทสินค้า</th>
                    <th class="all text-center" rowspan="2">ชื่อสินค้า</th>
                    <th class="all text-center" rowspan="2">
                      แบรนด์
                    </th>
                    <th class="all text-center" rowspan="2">จำนวน</th>
                    <th class="all text-center" rowspan="2">
                      ราคาเช่า/เครื่อง
                    </th>
                    <th class="all text-center" rowspan="2">รวมเงิน</th>
                    <th class="all text-center" rowspan="2">
                      ยอดเงินสุทธิในใบวางบิล
                    </th>
                    <th class="all text-center" colspan="2">สถานะ</th>
                  </tr>
                  <tr>
                    <th class="all text-center">วางบิลเสร็จสิ้น</th>
                    <th class="all text-center">ชำระแล้ว</th>
                  </tr>
                </thead>
                <tfoot>
                  <tr>
                    <th class="all text-right" colspan="9">รวม</th>
                    <th class="text-center">
                      {{ reInvLastQty | currency(" ", 0) }}
                    </th>
                    <th class="text-center">
                      {{ reInvLastPrice | currency(" ", 0) }}
                    </th>
                    <th class="text-center">
                      {{ reInvLastPriceTotal | currency(" ", 0) }}
                    </th>
                    <th class="text-center">
                      {{ reInvLastGrandPriceTotal | currency(" ", 0) }}
                    </th>
                    <th class="text-center" colspan="2"></th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
  },
  data: function() {
    var self = this;

    return {
      reInvDateStart: null,
      reInvDateEnd: null,
      reAaIsInitial: true,
      reAaDateReq: null,
      reInvPhase: null,
      reInvLot: null,
      reInvBrand: null,
      reInvStatus: null,
      reInvInvoice: null,
      reInvProductTypeId: null,
      reInvSupplier: null,
      reInvPriceStart: null,
      reInvPriceEnd: null,
      reInvLastQty: null,
      reInvLastPrice: null,
      reInvLastPriceTotal: null,
      reInvLastGrandPriceTotal: null,

      reInvStatusOptions: {
        placeholder: "กรุณาเลือกสถานะ",
        allowClear: true,
        data: [
          { id: "วางบิลเสร็จสิ้น", text: "วางบิลเสร็จสิ้น", data: null },
          { id: "ชำระแล้ว", text: "ชำระแล้ว", data: null },
        ],
      },
      reInvProductTypeIdOptions: {
        placeholder: "กรุณาเลือกแบรนด์สินค้า",
        data: [
          { id: "3", text: "เครื่องทำความเย็น", data: null },
          { id: "6", text: "หัวจ่าย", data: null },
        ],
      },
      reInvSupplierOptions: {
        placeholder: "กรุณาเลือกSupplier",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Vendors/Select2Vendor",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reInvPhaseOptions: {
        placeholder: "กรุณาเลือกPhase",
        allowClear: true,
        ajax: {
          url: "/Api/MasterPhase/Select2Phase",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reInvLotOptions: {
        placeholder: "กรุณาเลือกLot",
        allowClear: true,
        ajax: {
          url: "/Api/MasterPhase/Select2Lot",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              Phase: self.reInvPhase,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reInvBrandOptions: {
        placeholder: "กรุณาเลือกแบรนด์เครื่องเบียร์สด",
        allowClear: true,
        ajax: {
          url: "/Api/ProductBrand/Select2BrandMachine",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              ProductType: "3,6",
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
        templateResult: function(data) {
          return data.text;
        },
        language: {
          noResults: function() {
            return "ไม่พบข้อมูลร้านค้า";
          },
        },
      },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;
      self.reInvDateStart = null;
      self.reInvDateEnd = null;
      self.reInvPhase = null;
      self.reInvLot = null;
      self.reInvBrand = null;
      self.reInvStatus = null;
      self.reInvInvoice = null;
      self.reInvProductTypeId = null;
      self.reInvSupplier = null;
      self.reInvPriceStart = null;
      self.reInvPriceEnd = null;

      $("#reInvPhase")
        .val("")
        .trigger("change");

      $("#reInvLot")
        .val("")
        .trigger("change");

      $("#reInvBrand")
        .val("")
        .trigger("change");

      $("#reInvStatus")
        .val("")
        .trigger("change");

      $("#reInvProductTypeId")
        .val("")
        .trigger("change");

      $("#reInvSupplier")
        .val("")
        .trigger("change");

      this.formSubmit(e);

      //var table = $("#InvoiceTable").DataTable();
      //table.draw();
    },
    formSubmit: function(e) {
      let self = this;

      e.preventDefault();
      var table = $("#InvoiceTable").DataTable();
      table.draw();
    },
    exportInvoice: function(e) {
      e.preventDefault();
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportInvoice",
        responseType: "arraybuffer",
        data: {
          DateStart:
            self.reInvDateStart != null
              ? self.reInvDateStart.format("DD/MM/YYYY")
              : self.reInvDateStart,
          DateEnd:
            self.reInvDateEnd != null
              ? self.reInvDateEnd.format("DD/MM/YYYY")
              : self.reInvDateEnd,
          Phase: self.reInvPhase,
          Lot: self.reInvLot,
          Brand: self.reInvBrand,
          Status: self.reInvStatus,
          Invoice: self.reInvInvoice,
          ProductTypeId: self.reInvProductTypeId,
          PriceStart: self.reInvPriceStart,
          PriceEnd: self.reInvPriceEnd,
          Supplier: self.reInvSupplier
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
  },
  async mounted() {
    let self = this;

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

    $(self.$refs.reInvDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reBcTransferJobCommitDateStart = moment().set("date",1);
    $(self.$refs.reInvDateStart)
      .datepicker(
        "update",
        !!self.reInvDateStart ? self.reInvDateStart.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reInvDateStart = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reInvDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reBcTransferJobCommitDateStart = moment().set("date",1);
    $(self.$refs.reInvDateEnd)
      .datepicker(
        "update",
        !!self.reInvDateEnd ? self.reInvDateEnd.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reInvDateEnd = e.dates.length != 0 ? moment(e.date) : null;
      });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#InvoiceTable");
    //begin first table
    table
      .DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/Invoice",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            let jsonSearch = {
              DateStart: self.reInvDateStart
                ? self.reInvDateStart.format("DD/MM/YYYY")
                : null,
              DateEnd: self.reInvDateEnd
                ? self.reInvDateEnd.format("DD/MM/YYYY")
                : null,
              Phase: self.reInvPhase,
              Lot: self.reInvLot,
              Brand: self.reInvBrand,
              Status: self.reInvStatus,
              Invoice: self.reInvInvoice,
              ProductTypeId: self.reInvProductTypeId,
              PriceStart: self.reInvPriceStart,
              PriceEnd: self.reInvPriceEnd,
              Supplier: self.reInvSupplier,
              IsInitial: self.reAaIsInitial
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [100, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },
        // Order settings
        order: [[0, "desc"]],
        columns: [
          {
            data: "date",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.dateStringFormat;
            },
          },
          {
            data: "invoice",
            className: "text-center",
            orderable: false,
          },
          {
            data: "phase",
            className: "text-center",
            orderable: false,
          },
          {
            data: "lot",
            className: "text-center",
            orderable: false,
          },
          {
            data: "trancheNo",
            className: "text-center",
            orderable: false,
          },
          {
            data: "supplierName",
            className: "text-center",
            orderable: false,
          },
          {
            data: "productTypeName",
            className: "text-center",
            orderable: false,
          },
          {
            data: "productName",
            className: "text-center",
            orderable: false,
          },
          {
            data: "productBrand",
            className: "text-center",
            orderable: false,
          },
          {
            data: "qty",
            className: "text-center",
            orderable: false,
          },
          {
            data: "price",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              if (data != null) {
                return data
                  .toFixed(0)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          {
            data: "priceTotal",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              if (data != null) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          {
            data: "priceGrandtotal",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              if (data != null) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          {
            data: "billStatus",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              if (data) {
                var value = full.priceGrandtotal
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return (
                  '<p class="text-success">' +
                  value +
                  '<br><i class="fas fa-check-circle text-success"></i>'
                );
              } else {
                return '<i class="fas fa-times-circle text-danger"></i>';
              }
            },
          },
          {
            data: "paymentStatus",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              if (data) {
                return '<i class="fas fa-check-circle text-success"></i>';
              } else {
                return '<i class="fas fa-times-circle text-danger"></i>';
              }
            },
          },
          //<i class="kt-font-priceTier flaticon-file-1 kt-font-success"></i>
        ],
        rowCallback: function(row, data, index) {
          $(row)
            .find("td:eq(11)")
            .css("background-color", "#F2DCDB");
        },
        drawCallback: function(settings) {
          self.reAaIsInitial = false;
          self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

          if (settings.json.data.length === 0) {
            self.reInvLastQty = 0;
            self.reInvLastPrice = 0;
            self.reInvLastPriceTotal = 0;
            self.reInvLastGrandPriceTotal = 0;
            return false;
          }

          var table = $("#InvoiceTable");
          var rows = table.find($("tr"));
          var prevCheck = "";
          var mergeRow = 1;

          for (var r = 0; r <= rows.length; r++) {
            var dateOfBilling = $($(rows[r]).find("td")[0]).text();
            var phase = $($(rows[r]).find("td")[2]).text();
            var lot = $($(rows[r]).find("td")[3]).text();
            var trancheNo = $($(rows[r]).find("td")[4]).text();
            var check = `${dateOfBilling}#${phase}#${lot}#${trancheNo}`;
            if (prevCheck == "") {
              prevCheck = check;
              continue;
            }
            if (prevCheck == check) {
              mergeRow = mergeRow + 1;
              continue;
            }

            //hide col
            var cols = [0, 1, 2, 3, 4, 12, 13, 14];
            for (var h = 1; h < mergeRow; h++) {
              for (var i = 0; i < cols.length; i++) {
                let c = cols[i];
                $($(rows[r - h]).find("td")[c]).hide();
              }
            }

            for (var i = 0; i < cols.length; i++) {
              let c = cols[i];
              $($(rows[r - mergeRow]).find("td")[c]).attr("rowspan", mergeRow);
            }

            mergeRow = 1;
            prevCheck = check;
          }

          // var colsLength = 13;
          // var removeLater = new Array();
          // for (var i = 0; i < colsLength; i++) {
          //   if (i == 0 || i == 1 || i == 2 || i == 3) {
          //     var startIndex = 0;
          //     var lastIndex = 0;
          //     var startText = $($(rows[0]).find("td")[i]).text();
          //     for (var j = 1; j < rows.length; j++) {
          //       var cRow = $(rows[j]);
          //       var cCol = $(cRow.find("td")[i]);

          //       var currentText = cCol.text();

          //       if (currentText == startText) {
          //         removeLater.push(cCol);
          //         lastIndex = j;
          //         if (i == 1) {
          //           var cCol1 = $(cRow.find("td")[i + 10]);
          //           var cCol2 = $(cRow.find("td")[i + 11]);
          //           var cCol3 = $(cRow.find("td")[i + 12]);
          //           removeLater.push(cCol1);
          //           removeLater.push(cCol2);
          //           removeLater.push(cCol3);
          //         }
          //       } else {
          //         var spanLength = lastIndex - startIndex;
          //         if (spanLength >= 1) {
          //           $($(rows[startIndex]).find("td")[i]).attr(
          //             "rowspan",
          //             spanLength + 1
          //           );
          //         }

          //         if (i == 1) {
          //           $($(rows[startIndex]).find("td")[i + 10]).attr(
          //             "rowspan",
          //             spanLength + 1
          //           );
          //           $($(rows[startIndex]).find("td")[i + 11]).attr(
          //             "rowspan",
          //             spanLength + 1
          //           );
          //           $($(rows[startIndex]).find("td")[i + 12]).attr(
          //             "rowspan",
          //             spanLength + 1
          //           );
          //         }

          //         lastIndex = j;
          //         startIndex = j;
          //         startText = currentText;
          //       }
          //     }

          //     var spanLength = lastIndex - startIndex;
          //     if (spanLength >= 1) {
          //       $($(rows[startIndex]).find("td")[i]).attr(
          //         "rowspan",
          //         spanLength + 1
          //       );

          //       if (i == 1) {
          //         $($(rows[startIndex]).find("td")[i + 10]).attr(
          //           "rowspan",
          //           spanLength + 1
          //         );
          //         $($(rows[startIndex]).find("td")[i + 11]).attr(
          //           "rowspan",
          //           spanLength + 1
          //         );
          //         $($(rows[startIndex]).find("td")[i + 12]).attr(
          //           "rowspan",
          //           spanLength + 1
          //         );
          //       }
          //     }
          //   }
          // }

          // for (var i in removeLater) {
          //   $(removeLater[i]).hide();
          // }

          //========================
          var allPage = table.DataTable().page.info().pages;
          var currentPage = table.DataTable().page.info().page + 1;

          self.reInvLastQty = settings.json.data[0].totalRecord.qty;
          self.reInvLastPrice = settings.json.data[0].totalRecord.price;
          self.reInvLastPriceTotal =
            settings.json.data[0].totalRecord.priceTotal;
          self.reInvLastGrandPriceTotal =
            settings.json.data[0].totalRecord.priceGrandtotal;
          $.fn.dataTable.tables({ visible: true, api: true }).columns.adjust();
        },
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        // var t = table.DataTable();
        // var page = t.page.info().start + 1;
        // t.column(0, {}).nodes().each( function (cell, i) {
        //     cell.innerHTML = i+page;
        // } );
      });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/Invoice.vue